import { colors, fonts } from '@grupoboticario/flora-tokens/dist/boticario/web/ds'

export const boticario = {
  colors,
  fonts,
}
